export const roundNumber = (value: number): number => Math.round(value * 100) / 100;
